import { useCartContext } from "app/providers/CartProvider";
import { concatClassnames } from "shared/utils/concatClassnames";
import SidebarStandardProduct from "../sidebar-panel-item";

const CheckoutSidebarStandardProductList = () => {
  const cartContext = useCartContext();
  const { standardProducts } = cartContext.getCart();

  const setPanelAmount = (id: number, amount: number) => {
    cartContext.changeCartStandardProductAmount(id, amount);
  };

  return (
    <div>
      {standardProducts ? (
        standardProducts.map((standardProduct, id) => {
          return (
            <SidebarStandardProduct
              standardProduct={standardProduct}
              index={id}
              key={`panel-${standardProduct.id}-${id}`}
              setPanelAmount={(amount) => setPanelAmount(id, amount)}
              className={concatClassnames(
                id !== standardProducts.length - 1 && "gg-border-b",
                id !== 0 && "gg-pt-9",
                id !== standardProducts.length - 1 ? "lg:gg-pb-9" : "lg:gg-pb-2"
              )}
            />
          );
        })
      ) : (
        <></>
      )}
    </div>
  );
};
export default CheckoutSidebarStandardProductList;
